import React from 'react'
import { Page } from '../components/ui/Page'    
import { Body } from '../components/layout/Body';

export default function AccessPage() {
    return (
        <div className="max-w-[1200px] mx-auto">
            <Page>
                <Body>
                    <h1 className='text-2xl mt-16 mb-8 font-bold'>Barrierefreiheitserklärung</h1>
                    <p>[Name/Firma] ist bemüht, die Website [Website-URL] im Einklang mit dem Web-Zugänglichkeits-Gesetz (WZG) zur Umsetzung der Richtlinie (EU) 2016/2102 barrierefrei zugänglich zu machen.</p>

                    <h2 className='text-lg'>Stand der Vereinbarkeit mit den Anforderungen</h2>
                    <p>Diese Website ist [vollständig/teilweise/nicht] mit der Konformitätsstufe AA der "Richtlinien für barrierefreie Webinhalte Web Content Accessibility Guidelines (WCAG) 2.1" vereinbar.</p>

                    <h2 className='text-lg'>Nicht barrierefreie Inhalte</h2>
                    <p>[Auflistung bekannter Probleme]</p>

                    <h2 className='text-lg'>Feedback und Kontaktmöglichkeiten</h2>
                    <p>Wenn Sie Mängel in Bezug auf die barrierefreie Gestaltung dieser Website feststellen, kontaktieren Sie uns bitte unter [E-Mail/Telefon].</p>

                    <h2 className='text-lg'>Durchsetzungsverfahren</h2>
                    <p>Bei nicht zufriedenstellenden Antworten können Sie sich an die Schlichtungsstelle wenden:<br />
                        Österreichische Forschungsförderungsgesellschaft mbH (FFG)<br />
                        Sensengasse 1, 1090 Wien<br />
                        E-Mail: schlichtungsstelle@ffg.at</p>
                </Body>
            </Page>
        </div>
    )
}
